import {renderCell} from '@components/statistics/stats-reports/cell'
import {BooleanHookState} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import React from 'react'
import {Lang} from 'yougile-lang'
import {TaskData} from 'yougile-model'
import {Util} from 'yougile-util'
import {DropZone} from '../stats-reports-table'
import {Dash} from './dash'
import {EmptyContent, isBetween, PropsSubtasksTR} from './subtasks-in-report'
import {Toggler} from './toggler'

interface PropsSubtasks_TR extends PropsSubtasksTR {
  offsetTop: number
  taskData: TaskData
  toggle: () => void
  open: BooleanHookState
}

export const SubTR = (props: PropsSubtasks_TR) => {
  const bem = Util.bemFrom('stats-reports-table')
  return (
    <>
      {!isBetween(
        props.offsetTop,
        props.topWithReserve,
        props.bottomWithReserve
      ) ? (
        <EmptyContent allFields={props.allFields} />
      ) : (
        props.offsetTop &&
        props.allFields.map((f, ix) => {
          const fieldKey = f(Lang.msg).key
          return (
            <td
              className={bem('body-cell', {
                resize: props.resizeColumnIndex === ix
              })}
              key={ix}
            >
              <DropZone
                allFields={props.allFields}
                ix={ix}
                columnWidths={props.columnWidths}
                dragCtl={props.dragCtl}
              />
              <div
                style={{
                  width:
                    props.columnWidths[fieldKey] ??
                    props.getDefaultColumnWidth(fieldKey)
                }}
                className={cn(
                  'relative',
                  props.dragCtl.draggedId === ix && 'opacity-30'
                )}
              >
                <div className="flex items-center h-24">
                  {fieldKey === 'title' && (
                    <>
                      <Dash
                        hasSubtasks
                        hasStraightLine={props.hasStraightLine}
                        taskId={props.taskId}
                        itemsY={props.itemsY}
                      />
                      <Toggler
                        arrowDown={props.open.value}
                        onToggle={props.toggle}
                      />
                    </>
                  )}
                  {renderCell(f, props.taskData)}
                </div>
              </div>
            </td>
          )
        })
      )}
    </>
  )
}
